
export default function(state = null, action) {
    switch (action.type) {
      case "GET_PENDING_AMOUNT_ACTION":
        return action.payload;
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/reducer/get_pending_amount.js